import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "co-pagination"
}
const _hoisted_2 = ["onClick"]

import { computed } from "vue";
import ArrowIcon from "@web/assets/icon/arrow.svg";

// Props
type Props = {
	totalPages: number;
	maxVisible: number;
	modelValue: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationObject',
  props: {
    totalPages: {},
    maxVisible: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

const pages = computed(() => {
	function range(start: number, end: number) {
		return Array.from(Array(end - start + 1), (_, i) => i + start);
	}

	const max = props.maxVisible;
	const middle = Math.floor(props.maxVisible / 2);
	const pageNum = props.totalPages;

	if (pageNum < max) {
		return range(1, pageNum);
	}

	let start = props.modelValue - middle;
	let end = props.modelValue + middle;

	// If we're close to the end
	if (props.modelValue >= pageNum - middle) {
		start = pageNum - max + 1;
		end = pageNum;
	}

	return range(Math.max(1, start), Math.max(end, max));
});

function onPageClick(page: number) {
	emit("update:modelValue", page);
	emit("updated", page);
}

function onPageBack() {
	if (props.modelValue - 1 >= 1) {
		onPageClick(props.modelValue - 1);
	}
}
function onPageForward() {
	if (props.modelValue + 1 <= props.totalPages) {
		onPageClick(props.modelValue + 1);
	}
}

return (_ctx: any,_cache: any) => {
  return (props.totalPages > 1)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", {
          class: _normalizeClass(["co-pagination__item prev", { disabled: props.modelValue == 1 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onPageBack()))
        }, [
          _createVNode(_unref(ArrowIcon))
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (i, y) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (y < props.maxVisible)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 'pagination-page-' + i,
                  class: _normalizeClass(["co-pagination__item bullet", { 'bullet--active': props.modelValue == i }]),
                  onClick: ($event: any) => (onPageClick(i))
                }, _toDisplayString(i), 11, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
        _createElementVNode("li", {
          class: _normalizeClass(["co-pagination__item next", { disabled: props.modelValue == props.totalPages }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onPageForward()))
        }, [
          _createVNode(_unref(ArrowIcon))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})